module.exports = __webpack_public_path__ + "img/睦邻中心2.fe1fe3a4.jpg";